import React, { useEffect, useRef, useState } from "react";
// LEGACY build: eski brauzerlarda (eski Chrome/Safari/Yandex) ham ishlaydi — oddiy build zamonaviy JS talab qiladi.
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import classes from "./DarsJadvali.module.css";

// Worker `public/` papkasidan beriladi (node_modules/pdfjs-dist/legacy/build/pdf.worker.min.js nusxasi).
// `?v=` — brauzer keshida turgan eski worker o'rniga aynan shu versiya yuklansin.
const WORKER_VERSION = "3.11.174-legacy";
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js?v=${WORKER_VERSION}`;

/**
 * PDF'ni sahifaning o'zida chizadi (pdf.js). iframe/embed ishlatilmaydi:
 * serverdagi media X-Frame-Options: DENY bilan keladi va brauzer uni frame ichida bloklaydi.
 */
const PdfViewer = ({ url, loadingText, errorText, openText }) => {
  const containerRef = useRef(null);
  const [state, setState] = useState({ status: "loading", pages: 0, detail: "" });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    let loadingTask = null;
    const container = containerRef.current;
    if (!container || !url) return undefined;

    container.innerHTML = "";
    setState({ status: "loading", pages: 0, detail: "" });

    const render = async () => {
      try {
        loadingTask = pdfjsLib.getDocument({ url, withCredentials: false });
        const pdf = await loadingTask.promise;
        if (cancelled) return;

        // Sahifa kengligi konteynerga moslanadi; devicePixelRatio bilan matn keskin chiqadi.
        const availableWidth = Math.max(container.clientWidth - 2, 320);
        const dpr = window.devicePixelRatio || 1;

        for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber += 1) {
          if (cancelled) return;
          const page = await pdf.getPage(pageNumber);
          const baseViewport = page.getViewport({ scale: 1 });
          const scale = availableWidth / baseViewport.width;
          const viewport = page.getViewport({ scale });

          const canvas = document.createElement("canvas");
          canvas.className = classes.pdfPage;
          canvas.width = Math.floor(viewport.width * dpr);
          canvas.height = Math.floor(viewport.height * dpr);
          canvas.style.width = `${Math.floor(viewport.width)}px`;
          canvas.style.height = `${Math.floor(viewport.height)}px`;
          container.appendChild(canvas);

          const ctx = canvas.getContext("2d");
          await page.render({
            canvasContext: ctx,
            viewport,
            transform: dpr !== 1 ? [dpr, 0, 0, dpr, 0, 0] : undefined,
          }).promise;
        }

        if (!cancelled) setState({ status: "ready", pages: pdf.numPages, detail: "" });
      } catch (err) {
        if (!cancelled) {
          console.error("PDF render error:", err);
          // Sabab ekranda ko'rinsin — "xatolik" so'zining o'zi diagnostika uchun yetarli emas.
          const detail = err && (err.message || err.name) ? String(err.message || err.name) : "";
          setState({ status: "error", pages: 0, detail });
        }
      }
    };

    render();

    return () => {
      cancelled = true;
      if (loadingTask) loadingTask.destroy();
    };
  }, [url, attempt]);

  return (
    <div className={classes.pdfWrap}>
      {state.status === "loading" && <div className={classes.state}>{loadingText}</div>}
      {state.status === "error" && (
        <div className={`${classes.state} ${classes.error}`}>
          <div>{errorText}</div>
          {state.detail && <div className={classes.errorDetail}>{state.detail}</div>}
          <div className={classes.errorActions}>
            <button type="button" className={classes.retryBtn} onClick={() => setAttempt((a) => a + 1)}>
              ↻
            </button>
            <a href={url} target="_blank" rel="noopener noreferrer" className={classes.openBtn}>
              {openText}
            </a>
          </div>
        </div>
      )}
      <div ref={containerRef} className={classes.pdfPages} />
    </div>
  );
};

export default PdfViewer;
